<template>
  <v-window-item value="settings-info">
    <v-card-text>
      <v-card variant="outlined" class="mb-4">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-map-marker-radius</v-icon>
          Location Information
        </v-card-title>
        <v-card-text>
          <v-card variant="tonal" class="py-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item prepend-icon="mdi-latitude" title="Latitude" :subtitle="(userSettingsInfoData?.employee?.latitude) || 'N/A'" />
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item prepend-icon="mdi-longitude" title="Longitude" :subtitle="(userSettingsInfoData?.employee?.longitude) || 'N/A'" />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-clock-outline</v-icon>
          Overtime Information
        </v-card-title>
        <v-card-text>
          <v-card variant="tonal" class="py-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item prepend-icon="mdi-clock-check-outline" title="OT Applicable" :subtitle="(userSettingsInfoData?.ot_applicable) || 'N/A'" />
                <v-list-item prepend-icon="mdi-calendar-today" title="Daily OT Type" :subtitle="(userSettingsInfoData?.daily_ot_type) || 'N/A'" />
                <v-list-item prepend-icon="mdi-percent-outline" title="Daily OT Rate" :subtitle="(userSettingsInfoData?.daily_ot_rate) || 'N/A'" />
                <v-list-item prepend-icon="mdi-cash-check" title="Daily OT Pay On" :subtitle="(userSettingsInfoData?.daily_ot_pay_on) || 'N/A'" />
                <v-list-item prepend-icon="mdi-cash-plus" title="Daily OT Amount" :subtitle="(userSettingsInfoData?.daily_ot_amount) || 'N/A'" />
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item prepend-icon="mdi-clock-edit-outline" title="Hourly OT Type" :subtitle="(userSettingsInfoData?.hourly_ot_type) || 'N/A'" />
                <v-list-item prepend-icon="mdi-percent-outline" title="Hourly OT Rate Percentage" :subtitle="(userSettingsInfoData?.hourly_ot_rate_percentage) || 'N/A'" />
                <v-list-item prepend-icon="mdi-cash" title="Hourly OT Rate" :subtitle="(userSettingsInfoData?.hourly_ot_rate) || 'N/A'" />
                <v-list-item prepend-icon="mdi-cash-check" title="Hourly OT Pay On" :subtitle="(userSettingsInfoData?.hourly_ot_pay_on) || 'N/A'" />
                <v-list-item prepend-icon="mdi-cash-plus" title="Hourly OT Amount" :subtitle="(userSettingsInfoData?.hourly_ot_amount) || 'N/A'" />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script setup>
defineProps({
  userSettingsInfoData: {
    type: Object,
    default: () => ({})
  }
})
</script>
